import { render } from "./Popitem.vue?vue&type=template&id=0318f7bb"
import script from "./Popitem.vue?vue&type=script&lang=js"
export * from "./Popitem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mfeys\\Desktop\\HAv2\\actions\\18597-ocebio\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__